var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48.725mm",
    height: "60.906mm",
    viewBox: "0 0 48.725 60.906",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-74.007 -70.449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m98.369 70.449c-12.79 0-24.362 9.8058-24.362 24.971 0 10.11 8.131 22.078 24.362 35.934 16.231-13.856 24.362-25.824 24.362-35.934 0-15.166-11.572-24.971-24.362-24.971zm-0.28556 23.886c-3.3498 0 0.42828 3.6591 0.42828 0.30962 0-3.3498-3.4212-0.046-0.0714-0.046 3.3498 0 0.0242-3.3261 0.0242 0.023 0 3.3498 2.9692-0.28544-0.38063-0.28544z",
    fill: "#898196"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffd42a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.428,
    cy: 110.16,
    r: 4.2333
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.977,
    cy: 97.595,
    r: 6.4823
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.12,
    cy: 89.128,
    r: 8.599
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.9ee1987174f3c733362fbf04a488c8b4.svg";
export { ForwardRef as ReactComponent };